var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "subscription-group",
      class: _vm.$vuetify.theme.dark ? "shadow-dark" : "shadow-light",
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        { staticClass: "subscription-group__name" },
                        "div",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v(" " + _vm._s(_vm.name) + " "),
                      _c("span", { staticClass: "tenant-name" }, [
                        _vm._v(" - " + _vm._s(_vm.tenant) + " "),
                      ]),
                    ]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm.channels.length > 0
            ? _c(
                "div",
                _vm._l(_vm.channels, function (channelItem, channelIndex) {
                  return _c(
                    "div",
                    { key: `channel-item-key-${channelIndex}` },
                    [_vm._v(" - " + _vm._s(channelItem.description) + " ")]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no-results" }, [
                _vm._v("no channels assigned"),
              ]),
        ]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        { staticClass: "subscription-group__description" },
                        "div",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_vm._v(_vm._s(_vm.description))]
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.description))])]
      ),
      _c(
        "div",
        { staticClass: "subscription-group__action" },
        [
          _c(
            "v-menu",
            {
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          {
                            staticStyle: { height: "24px", width: "24px" },
                            attrs: { small: "" },
                          },
                          on
                        ),
                        [_vm._v(" fas fa-cog ")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "v-list",
                { staticClass: "accent" },
                _vm._l(_vm.actions, function (item, index) {
                  return _c(
                    "v-list-item",
                    {
                      key: index,
                      attrs: { value: index },
                      on: { click: item.action },
                    },
                    [_c("v-list-item-title", [_vm._v(_vm._s(item.title))])],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }